import React from 'react';
import './Partners.css';

// Import partners Data
import { partners } from '../../../constants';

// Import Swiper core and required modules
import { Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';



const Partners = () => {

  return (
    <section className='partners'>

      {/* Partner Slider Container */}
      <div className='partner-slider'>

        <Swiper
          // Install Swiper modules
          modules={[Autoplay]}
          spaceBetween={20}
          loop={true}
          autoplay={{ delay: 5000, disableOnInteraction: false }} // Auto-scroll every 5 seconds
          breakpoints={{
            0: { slidesPerView: 2 },      // 2 slides for small screens
            450: { slidesPerView: 3 },    // 3 slides for medium screens
            768: { slidesPerView: 4 },    // 4 slides for tablets
            1024: { slidesPerView: 5 },   // 5 slides for desktops
          }} 
        >
        {/* Map over the partners array to render each partner logo */}
        {partners.map((partner, index) => {
            return (
              /* Render the partner image */
              <SwiperSlide className='partner-item' key={index}><img src={partner} alt='Partner Logo' /></SwiperSlide>
            )
          })
        }
        </Swiper>
      </div>
    </section>
  );
}

export default Partners;